import { isEqual } from 'lodash'
import { TFormFieldData } from '@gismart/ui.library/core/types'

// Sync version of form.getFieldValue
export const getFormFieldValue = (
  fieldName: string[],
  fields?: TFormFieldData[],
): any | null =>
  fields?.find(({ name }) => isEqual(fieldName, name))?.value ?? null
